import { matchPath } from 'react-router-dom';

import { type Permissions, usePermissions } from '/module/permissions';
import { getAnchorProps } from '/module/routing/module';
import { ROUTES } from '/routes/config';

import type { SideNavItem } from './types';

export const getNavName = (name: string | ((v: Permissions) => string), permissions: Permissions) =>
  typeof name === 'function' ? name(permissions) : name;

export const getMainNavLink = (item: SideNavItem) => {
  const { icon, name, link } = item;
  const permissions = usePermissions();
  const route = item.link ? ROUTES[item.link] : undefined;

  const haveRoute =
    (route?.path && route.component) || (route && 'redirectExternal' in route && route.redirectExternal);

  if (!haveRoute) {
    return null;
  }

  const showInSidebar =
    'showInSidebar' in route
      ? typeof route.showInSidebar === 'function'
        ? route.showInSidebar(permissions)
        : route.showInSidebar
      : true;
  const accessDenied = 'accessDenied' in route && route.accessDenied ? route.accessDenied(permissions) : false;

  if (accessDenied || !showInSidebar) {
    return null;
  }

  const label = getNavName(name, permissions);

  const highlight: boolean =
    !!matchPath(window.location.pathname, route) ||
    (item.childRoutes
      ? item.childRoutes.some((c) => {
          const r = ROUTES[c];

          return matchPath(window.location.pathname, r);
        })
      : false);

  const target = 'redirectExternal' in route && route.redirectExternal ? '_blank' : undefined;

  if (!label || !link) return null;

  const anchor = getAnchorProps(item.link, { target });

  return {
    label,
    icon,
    highlight,
    'data-test': `main-nav-link-${item.link}`,
    ...{ ...anchor, title: label },
  } as const;
};
